import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const dairyIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  milk: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g>
          <path
            d="m170.502 511.796c9.085 0 16.579-7.114 17.05-16.187l17.317-333.019c.254-4.882-3.636-8.98-8.525-8.98h-187.807c-4.889 0-8.779 4.098-8.525 8.98l17.317 333.02c.472 9.073 7.965 16.187 17.05 16.187h136.123z"
            fill="#d3effb"
          ></path>
          <path
            d="m43.083 333.324 7.084 136.232c.236 4.536 3.983 8.093 8.525 8.093h87.497c4.542 0 8.289-3.557 8.525-8.093l7.084-136.232c.254-4.882-3.636-8.98-8.525-8.98h-101.665c-4.889 0-8.779 4.098-8.525 8.98z"
            fill="#f9f5f8"
          ></path>
          <path
            d="m196.344 153.61h-23.692c4.889 0 8.779 4.098 8.525 8.98l-17.316 333.02c-.472 9.073-7.965 16.187-17.05 16.187h23.692c9.085 0 16.579-7.114 17.05-16.187l17.317-333.019c.253-4.883-3.637-8.981-8.526-8.981z"
            fill="#b1e4f9"
          ></path>
          <path
            d="m153.273 324.344h-23.692c4.889 0 8.779 4.098 8.525 8.98l-7.084 136.232c-.236 4.536-3.983 8.093-8.525 8.093h23.692c4.542 0 8.289-3.557 8.525-8.093l7.084-136.232c.254-4.882-3.636-8.98-8.525-8.98z"
            fill="#e2d8ec"
          ></path>
        </g>
        <path
          d="m499.661 170.113-41.219-58.884c-4.016-5.737-6.17-12.57-6.17-19.572v-74.566h-153.584v74.566c0 7.003-2.154 13.836-6.17 19.572l-41.218 58.884c-8.031 11.473-12.339 25.139-12.339 39.144v268.587c0 18.849 15.28 34.13 34.13 34.13h204.779c18.849 0 34.13-15.28 34.13-34.13v-268.587c0-14.005-4.308-27.671-12.339-39.144z"
          fill="#d3effb"
        ></path>
        <path
          d="m499.661 170.113-41.218-58.884c-4.016-5.737-6.17-12.57-6.17-19.572v-74.566h-23.692v74.566c0 7.003 2.154 13.836 6.17 19.572l41.218 58.884c8.031 11.473 12.339 25.139 12.339 39.144v268.587c0 18.849-15.28 34.13-34.13 34.13h23.692c18.85 0 34.13-15.281 34.13-34.13v-268.587c0-14.005-4.308-27.671-12.339-39.144z"
          fill="#b1e4f9"
        ></path>
        <path
          d="m442.006 153.61h-133.05c-2.784 0-5.393 1.359-6.99 3.64l-22.705 32.436c-4.016 5.737-6.169 12.569-6.169 19.572v251.522c0 9.425 7.64 17.065 17.065 17.065h170.65c9.425 0 17.065-7.64 17.065-17.065v-251.523c0-7.002-2.154-13.835-6.169-19.572l-22.705-32.435c-1.599-2.281-4.208-3.64-6.992-3.64z"
          fill="#f9f5f8"
        ></path>
        <path
          d="m471.701 189.685-22.705-32.436c-1.597-2.281-4.206-3.639-6.99-3.639h-23.692c2.784 0 5.393 1.358 6.99 3.639l22.705 32.436c4.016 5.737 6.17 12.57 6.17 19.572v251.522c0 9.425-7.64 17.065-17.065 17.065h23.692c9.425 0 17.065-7.64 17.065-17.065v-251.522c-.001-7.002-2.155-13.835-6.17-19.572z"
          fill="#e2d8ec"
        ></path>
        <g>
          <path
            d="m427.74 341.325h-104.52c-8.837 0-16-7.163-16-16v-36.26c0-8.837 7.163-16 16-16h104.52c8.836 0 16 7.163 16 16v36.26c0 8.836-7.163 16-16 16z"
            fill="#6bbef6"
          ></path>
          <g>
            <g>
              <path
                d="m409.61 314.921h-68.26c-4.267 0-7.726-3.458-7.726-7.726 0-4.267 3.458-7.726 7.726-7.726h68.26c4.267 0 7.726 3.458 7.726 7.726-.001 4.267-3.459 7.726-7.726 7.726z"
                fill="#d3effb"
              ></path>
            </g>
          </g>
          <path
            d="m427.259 273.065h-23.692c9.102 0 16.481 7.379 16.481 16.481v35.297c0 9.102-7.379 16.481-16.481 16.481h23.692c9.102 0 16.481-7.379 16.481-16.481v-35.297c0-9.102-7.379-16.481-16.481-16.481z"
            fill="#5ea5ec"
          ></path>
        </g>
        <path
          d="m453.338 34.156h-155.715c-8.837 0-16-7.163-16-16v-10.13c0-4.418 3.582-8 8-8h171.714c4.418 0 8 3.582 8 8v10.13c.001 8.836-7.163 16-15.999 16z"
          fill="#6bbef6"
        ></path>
        <path
          d="m461.097.026h-23.692c4.551 0 8.241 3.689 8.241 8.241v9.408c0 9.102-7.379 16.481-16.481 16.481h23.692c9.102 0 16.481-7.379 16.481-16.481v-9.409c0-4.551-3.69-8.24-8.241-8.24z"
          fill="#5ea5ec"
        ></path>
      </g>
    </svg>
  ),
  cheese: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M512,173.419L252.982,50.725c-15.809-7.44-33.341-10.499-50.757-9.108 C51.299,53.667,0,159.775,0,206.452h512V173.419z"
        fill="#FFF082"
      />
      <path
        d="M505.152,314.517c3.926-0.828,6.848-4.09,6.848-8.102V173.419H33.032 C14.789,173.419,0,188.208,0,206.452v231.226c0,18.243,14.789,33.032,33.032,33.032h168.04c3.471,0,6.565-2.177,7.716-5.451 c5.653-16.065,20.956-27.581,38.954-27.581s33.301,11.516,38.954,27.581c1.152,3.274,4.245,5.451,7.716,5.451h209.33 c4.561,0,8.258-3.698,8.258-8.258v-75.19c0-4.013-2.922-7.274-6.848-8.102c-14.957-3.153-26.184-16.426-26.184-32.321 C478.968,330.943,490.195,317.67,505.152,314.517z"
        fill="#FFDC64"
      />
      <g>
        <circle cx="421.16" cy="256" r="16.516" fill="#E1A546" />
        <circle cx="206.45" cy="371.61" r="16.516" fill="#E1A546" />
      </g>
      <circle cx="82.58" cy="396.39" r="24.774" fill="#FFC850" />
      <path
        d="M82.581,371.613c-10.052,0-18.662,6.012-22.547,14.614c3.107-1.403,6.529-2.227,10.16-2.227 c13.682,0,24.774,11.092,24.774,24.774c0,3.631-0.824,7.053-2.227,10.16c8.602-3.885,14.614-12.495,14.614-22.547 C107.355,382.705,96.263,371.613,82.581,371.613z"
        fill="#E1A546"
      />
      <circle cx="297.29" cy="239.48" r="24.774" fill="#FFC850" />
      <path
        d="M297.29,214.71c-10.052,0-18.662,6.012-22.547,14.614c3.107-1.403,6.529-2.227,10.16-2.227 c13.682,0,24.774,11.092,24.774,24.774c0,3.631-0.824,7.053-2.227,10.16c8.602-3.885,14.614-12.495,14.614-22.547 C322.065,225.801,310.973,214.71,297.29,214.70z"
        fill="#E1A546"
      />
      <circle cx="132.13" cy="272.52" r="41.29" fill="#FFC850" />
      <path
        d="M132.129,231.226c-15.665,0-29.129,8.827-36.126,21.681c5.858-3.189,12.471-5.165,19.609-5.165 c22.804,0,41.29,18.486,41.29,41.29c0,7.139-1.976,13.752-5.165,19.609c12.854-6.997,21.681-20.46,21.681-36.125 C173.419,249.712,154.933,231.226,132.129,231.226z"
        fill="#E1A546"
      />
      <circle cx="355.1" cy="371.61" r="41.29" fill="#FFC850" />
      <path
        d="M355.097,330.323c-15.665,0-29.129,8.827-36.125,21.681c5.858-3.189,12.471-5.165,19.609-5.165 c22.804,0,41.29,18.486,41.29,41.29c0,7.139-1.976,13.752-5.165,19.609c12.854-6.997,21.681-20.46,21.681-36.125 C396.387,348.809,377.901,330.323,355.097,330.323z"
        fill="#E1A546"
      />
      <path
        d="M0,214.71L0,214.71c18.243,0,33.032,14.789,33.032,33.032v148.645 c0,27.365,22.184,49.548,49.548,49.548h111.484c6.841,0,12.387,5.546,12.387,12.387l0,0c0,6.841-5.546,12.387-12.387,12.387H33.032 C14.789,470.71,0,455.921,0,437.677V214.71z"
        fill="#FFC850"
      />
    </svg>
  ),
  yogurt: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <path
            d="m297.689 202.12c-.591-.996-1.221-1.971-1.89-2.92-7.431-10.545-19.419-17.76-32.217-19.388-10.769-1.37-21.686 1.048-32.522.391s-22.748-5.728-26.062-16.066c-2.711-8.455 1.386-17.907 7.861-23.983 4.094-3.842 8.411-6.677 13.498-9.173 3.374-1.656 3.585-6.442.334-8.329-26.634-15.457-66.49-4.665-88.102 13.889-11.641 9.994-21.28 21.812-35.606 28.348-8.402 3.833-17.784 4.738-26.294 8.728-8.792 4.123-16.825 9.939-23.084 17.399-11.403 13.591-16.368 32.97-10.739 49.794 2.752 8.226 10.431 5.931 17.881 5.836 8.252-.105 235.26-2.825 240.295-3.063 5.331-13.365 3.971-29.121-3.353-41.463z"
            fill="#edf6ff"
          />
          <path
            d="m202.697 122.652c3.251 1.887 3.04 6.672-.334 8.329-5.087 2.497-9.404 5.331-13.498 9.173-6.474 6.076-10.571 15.528-7.861 23.983 3.315 10.338 15.226 15.409 26.062 16.066 6.322.383 12.671-.277 19.003-.624-9.273-1.713-18.262-6.679-21.072-15.442-2.711-8.455 1.386-17.907 7.861-23.983 4.094-3.842 8.411-6.677 13.498-9.173 3.374-1.656 3.585-6.442.334-8.329-12.304-7.14-27.429-8.67-42.274-6.43 6.483 1.101 12.677 3.178 18.281 6.43z"
            fill="#cde2ff"
          />
          <path
            d="m301.041 243.583c-5.03.24-10.111.128-15.151.197-3.52.04-6.55.11-9.13.19.13-.12.23-.25.29-.39 5.33-13.36 3.97-29.12-3.35-41.46-.6-1-1.23-1.97-1.89-2.92-7.06-10.02-18.23-17.01-30.3-19.09 7.38-.41 14.763-1.228 22.073-.298 12.8 1.63 24.787 8.838 32.217 19.388.67.95 1.3 1.92 1.89 2.92 7.319 12.34 8.681 28.103 3.351 41.463z"
            fill="#cde2ff"
          />
          <path
            d="m263.888 462.775h-188.685c-6.201 0-11.229-5.027-11.229-11.229v-56.143h211.142v56.143c.001 6.202-5.027 11.229-11.228 11.229z"
            fill="#5d91b9"
          />
          <path
            d="m250.117 395.403v56.143c0 6.202-5.027 11.229-11.229 11.229h25c6.201 0 11.229-5.027 11.229-11.229v-56.143z"
            fill="#4980ac"
          />
          <path
            d="m7.5 230.776v21.365c0 6.974 5.653 12.627 12.627 12.627h298.838c6.974 0 12.627-5.653 12.627-12.627v-21.365c0-6.974-5.653-12.627-12.627-12.627h-298.838c-6.974.001-12.627 5.654-12.627 12.627z"
            fill="#5d91b9"
          />
          <path
            d="m318.964 218.15h-23.993c6.974 0 12.627 5.653 12.627 12.627v21.365c0 6.974-5.653 12.627-12.627 12.627h23.993c6.974 0 12.627-5.653 12.627-12.627v-21.365c0-6.974-5.653-12.627-12.627-12.627z"
            fill="#4980ac"
          />
          <path
            d="m31.439 390.3v-125.532h276.213v125.532c0 18.41-14.925 33.335-33.335 33.335h-209.543c-18.41 0-33.335-14.925-33.335-33.335z"
            fill="#75cff9"
          />
          <path
            d="m283.659 264.768v125.532c0 18.411-14.925 33.335-33.335 33.335h23.993c18.41 0 33.335-14.924 33.335-33.335v-125.532z"
            fill="#62a4fb"
          />
          <path
            d="m208.492 310.899-116.354 21.944c-3.541.668-5.958 4.009-5.429 7.573 3.089 20.835 20.89 36.872 42.503 37.212.464.007.931-.038 1.387-.124l116.355-21.944c3.541-.668 5.958-4.009 5.429-7.573-3.089-20.835-20.89-36.873-42.503-37.212-.465-.007-.931.038-1.388.124z"
            fill="#edf6ff"
          />
          <path
            d="m504.5 126.817c0-43.251-35.388-78.236-78.788-77.581-41.486.626-75.5 34.425-76.374 75.907-.476 22.592 8.71 43.036 23.707 57.5 16.435 15.851 26.029 37.487 26.029 60.321v191.976c0 15.373 12.463 27.836 27.836 27.836s27.836-12.463 27.836-27.836v-191.975c0-22.472 8.893-44.222 25.275-59.605 15.067-14.148 24.479-34.243 24.479-56.543z"
            fill="#edf6ff"
          />
          <path
            d="m425.712 49.236c-4.339.065-8.589.514-12.735 1.276 36.134 6.62 63.523 38.258 63.523 76.305 0 22.301-9.412 42.396-24.479 56.543-16.382 15.383-25.275 37.133-25.275 59.605v191.974c0 10.268-5.563 19.23-13.836 24.056 4.114 2.399 8.894 3.78 14 3.78 15.373 0 27.836-12.462 27.836-27.836v-191.974c0-22.472 8.893-44.222 25.275-59.605 15.066-14.148 24.479-34.243 24.479-56.543 0-43.25-35.388-78.236-78.788-77.581z"
            fill="#cde2ff"
          />
        </g>
      </g>
      <g>
        <path d="m318.964 210.649h-9.477c-6.339-21.673-25.06-35.743-44.962-38.279-11.764-1.494-22.728.969-33.017.345-8.063-.484-17.178-4.03-19.367-10.862-1.828-5.707 1.62-12.265 5.851-16.233 3.356-3.151 6.957-5.59 11.679-7.91 8.73-4.297 9.205-16.647.783-21.544-12.112-7.03-27.292-9.729-43.896-7.806-14.523 1.683-29.426 6.862-41.963 14.586-3.527 2.173-4.625 6.793-2.452 10.319 2.172 3.527 6.792 4.623 10.319 2.452 24.616-15.165 50.137-15.322 65.77-8.879-19.06 11.216-24.32 27.278-20.375 39.592 4.652 14.52 20.551 20.526 32.746 21.258 11.381.691 22.276-1.675 32.028-.438 12.823 1.635 25.368 10.08 30.975 23.399h-242.752c5.072-13.98 15.715-24.001 29.02-30.237 13.727-6.438 24.457-2.854 46.898-22.795 3.096-2.751 3.376-7.492.625-10.588s-7.491-3.377-10.588-.625c-4.238 3.766-9.993 8.494-16.939 11.662-7.587 3.459-17.161 4.449-26.362 8.764-18.762 8.795-32.956 23.81-38.372 43.819h-15.01c-11.097 0-20.126 9.03-20.126 20.127v21.365c0 11.098 9.029 20.127 20.126 20.127h3.813v118.032c0 19.672 13.983 36.137 32.531 39.984v21.267c0 10.322 8.402 18.72 18.73 18.72h188.69c10.328 0 18.73-8.397 18.73-18.72v-21.267c18.549-3.847 32.532-20.313 32.532-39.984v-4.419c0-4.143-3.358-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v4.419c0 14.245-11.589 25.835-25.835 25.835h-209.543c-14.246 0-25.835-11.59-25.835-25.835v-118.031h261.213v78.612c0 4.143 3.358 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-78.612h3.813c11.098 0 20.126-9.029 20.126-20.127v-21.365c0-11.098-9.029-20.128-20.127-20.128zm-55.074 244.621h-188.69c-2.057 0-3.73-1.669-3.73-3.72v-20.416h196.15v20.416c0 2.052-1.673 3.72-3.73 3.72zm60.201-203.128c0 2.827-2.3 5.127-5.126 5.127h-298.839c-2.827 0-5.126-2.3-5.126-5.127v-21.365c0-2.827 2.3-5.127 5.126-5.127h298.838c2.827 0 5.126 2.3 5.126 5.127v21.365z" />
        <path d="m210.005 303.276c-2.919-.012 3.752-.949-119.258 22.196-7.548 1.42-12.58 8.471-11.458 16.043 3.819 25.759 25.928 43.613 50.024 43.613 2.457 0-4.255 1.012 119.03-22.198 7.548-1.421 12.581-8.471 11.458-16.043-3.687-24.873-24.633-43.215-49.796-43.611zm-80.757 66.852c-17.498-.313-32.09-12.891-35-30.051l115.601-21.801c17.496.315 32.085 12.893 34.994 30.05z" />
        <path d="m425.599 41.737c-45.541.687-82.8 37.691-83.76 83.247-.499 23.657 8.978 46.641 25.999 63.057 15.084 14.547 23.735 34.565 23.735 54.923v191.976c0 19.484 15.852 35.336 35.336 35.336s35.336-15.852 35.336-35.336v-191.975c0-20.733 8.35-40.466 22.91-54.138 17.06-16.021 26.844-38.622 26.844-62.01.001-47.644-39.041-85.889-86.4-85.08zm49.289 136.156c-17.567 16.496-27.642 40.214-27.642 65.072v191.975c0 11.213-9.123 20.336-20.336 20.336s-20.336-9.123-20.336-20.336v-191.976c0-24.407-10.323-48.361-28.322-65.72-14.227-13.721-21.832-32.168-21.415-51.943.789-37.462 31.505-68 68.989-68.565.365-.005.728-.008 1.092-.008 38.658 0 70.083 31.272 70.083 70.09-.001 19.545-7.854 37.684-22.113 51.075z" />
      </g>
    </svg>
  ),
  jben: (props) => (
    <svg
      id="fi_6106944"
      height="512"
      viewBox="0 0 128 128"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <linearGradient
        id="linear-gradient"
        gradientUnits="userSpaceOnUse"
        x1="55.81"
        x2="125.21"
        y1="40.19"
        y2="80.25"
      >
        <stop offset="0" stop-color="#d6ac8f"></stop>
        <stop offset=".53" stop-color="#e8cbb2"></stop>
        <stop offset="1" stop-color="#f9ead4"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        gradientUnits="userSpaceOnUse"
        x1="8.41"
        x2="106.43"
        y1="68.88"
        y2="68.88"
      >
        <stop offset="0" stop-color="#fff7eb"></stop>
        <stop offset=".21" stop-color="#fef4e5"></stop>
        <stop offset=".49" stop-color="#faebd4"></stop>
        <stop offset=".69" stop-color="#f7e3c3"></stop>
        <stop offset="1" stop-color="#f9ead4"></stop>
      </linearGradient>
      <linearGradient
        id="linear-gradient-3"
        gradientUnits="userSpaceOnUse"
        x1="67.98"
        x2="61.68"
        y1="41.5"
        y2="11.86"
      >
        <stop offset="0" stop-color="#fff"></stop>
        <stop offset=".29" stop-color="#fefcf9"></stop>
        <stop offset=".67" stop-color="#fcf4e8"></stop>
        <stop offset="1" stop-color="#f9ead4"></stop>
      </linearGradient>
      <path
        d="m84 100h29c3.54-3.54 6.71-9.88 6.59-15.2-.31-13.28-4.49-35.8-7.59-44.8-3.73-10.64-4.65-12.1-5.52-14.08l-42.48.08z"
        fill="url(#linear-gradient)"
      ></path>
      <path
        d="m106.43 25.88-42.43.12 15.7 12.75a1 1 0 0 1 .35.63c.68 4.7 7.31 51.33 7.13 59.26-.2 8.36-.58 11.6-1.56 13.53a115.37 115.37 0 0 1 -21.62 1.83c-28.06 0-42.59-9.11-47.52-12.59-3.82-2.7-8-9.09-8-16.73 0-12.8 6.55-34.63 8.3-45.08 2.04-12.6 7.7-15.84 7.7-15.84z"
        fill="url(#linear-gradient-2)"
      ></path>
      <g fill="#edcfb9">
        <path d="m76.49 93.33a2 2 0 0 1 -.22-4.06 49.14 49.14 0 0 0 7.2-1 2 2 0 1 1 1.41 3.82c-1.98.7-8.04 1.24-8.39 1.24z"></path>
        <path d="m73 76a2 2 0 0 1 1.82-2.24 62.09 62.09 0 0 0 7.41-1 2 2 0 0 1 1.05 3.94 60.55 60.55 0 0 1 -8 1.13 2 2 0 0 1 -2.28-1.83z"></path>
        <path d="m71.45 60.1a2 2 0 0 1 1.82-2.23 41.66 41.66 0 0 0 6.73-1 2 2 0 1 1 1.29 3.87 42.83 42.83 0 0 1 -7.61 1.17 2 2 0 0 1 -2.23-1.81z"></path>
        <path d="m40.77 92.11c-1.64-.36-3.27-.77-4.86-1.22a2 2 0 0 1 1.09-3.89c1.51.42 3.06.81 4.63 1.16a2 2 0 0 1 -.88 4z"></path>
        <path d="m61.51 94.46c-1.77 0-3.56-.11-5.32-.22a2 2 0 0 1 .26-4.07c1.7.11 3.43.18 5.14.21a2 2 0 1 1 -.08 4.08z"></path>
        <path d="m20.38 84.53c-4.17-2.83-8.77-6.81-11-11.31a.73.73 0 0 1 .32-1 .69.69 0 0 1 .94.23c3.48 4.8 7.59 6.61 11.79 8.53a2 2 0 1 1 -2 3.55z"></path>
        <path d="m42 76.5c-1.51-.33-3-.7-4.49-1.11a2 2 0 1 1 1.09-3.92c1.39.38 2.83.74 4.27 1a2 2 0 0 1 -.87 4z"></path>
        <path d="m61.19 78.65c-1.64 0-3.3-.1-4.92-.2a2 2 0 1 1 .25-4.07c1.57.1 3.17.17 4.75.2a2 2 0 1 1 -.08 4.07z"></path>
        <path d="m23.1 69.59c-3.33-2.3-8.21-5.06-10.72-10.19a.62.62 0 0 1 .28-.82.56.56 0 0 1 .77.19c3.67 4.74 7.57 5.52 11.66 7.23a2 2 0 1 1 -2 3.57z"></path>
        <path d="m43.32 60.5c-1.39-.29-2.78-.61-4.1-1a2 2 0 0 1 1-3.94c1.25.33 2.56.64 3.89.91a2 2 0 0 1 -.83 4z"></path>
        <path d="m60.85 62.36c-1.52 0-3-.09-4.5-.17a2 2 0 1 1 .25-4.07c1.41.08 2.86.14 4.32.17a2 2 0 1 1 -.07 4.07z"></path>
        <path d="m26.06 54.51c-3.27-2.14-8.23-4.7-10.77-9.82a.66.66 0 0 1 .3-.89.61.61 0 0 1 .83.21c4.17 4.34 7.52 5.28 11.55 6.9a2 2 0 1 1 -1.88 3.62z"></path>
      </g>
      <path
        d="m106.43 25.88c-2.94-6.75-19.97-11.88-42.43-11.88s-40.79 5.81-40.79 13 18.25 13 40.79 13a136 136 0 0 0 15.35-.87.3.3 0 0 0 .14-.54l-15.49-12.59z"
        fill="url(#linear-gradient-3)"
      ></path>
    </svg>
  ),
  mozzarella: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      {...props}
    >
      <path
        d="m438.86 166.47 6.56-11.17c-12.78-4.1-39.85 14.95-39.85 14.95l4.19-12.22c-17.37.13-29.62 14.03-30 14.46l-.01.01a80.645 80.645 0 0 1 -19.73 24.29l18.53-3.69c-3.72 15.68-25.01 26.76-25.01 26.76h18.51c-6.02 19.23-22.86 21.73-22.86 21.73l28.97 24.26h.01a138.333 138.333 0 0 1 29.59.59 40.741 40.741 0 0 0 29.71-16.58l-17.52-5.97s23.74-3.62 32.35-17.26l-18.73-2.48s25.18-8.49 38.58-31.71c6.44-18.78 23.85-19.91 23.85-19.91-31.61-19.78-57.14-6.06-57.14-6.06z"
        fill="#81c83d"
      ></path>
      <path
        d="m346.32 140.5 2.59-12.68c-13.42.23-32.86 26.98-32.86 26.98v-12.91c-10.18 5.07-20.03 19.75-20.03 19.75l12.14 79.17a.037.037 0 0 1 -.01.03c14.11-1.81 27.99-1.81 41.04.75 0 0 16.84-2.5 22.86-21.73h-18.51s21.29-11.08 25.01-26.76l-18.53 3.69a80.645 80.645 0 0 0 19.73-24.29l.01-.01a66.211 66.211 0 0 0 6.49-18.15c0-19.84 16.11-26.52 16.11-26.52-36.33-8.53-56.04 12.68-56.04 12.68z"
        fill="#9be147"
      ></path>
      <path
        d="m307.158 247.849a6.006 6.006 0 0 1 -5.785-7.6c.7-2.533 17.73-62.47 64.011-100.6a6 6 0 1 1 7.631 9.261c-43.389 35.753-59.917 93.966-60.079 94.55a6 6 0 0 1 -5.778 4.389z"
        fill="#85ba3a"
      ></path>
      <path
        d="m368.525 256.667a6 6 0 0 1 -4.932-9.409c1.513-2.191 37.7-53.918 93.843-75.086a6 6 0 0 1 4.234 11.228c-52.671 19.857-87.852 70.169-88.2 70.675a5.992 5.992 0 0 1 -4.945 2.592z"
        fill="#6ba331"
      ></path>
      <path
        d="m457.99 299.72-112.99 64.44-33.87 22.4c1.04 1.11 33.88 35.21 107.22 3.92 59.57-25.42 40.14-89.14 39.64-90.76z"
        fill="#e0d7d5"
      ></path>
      <path
        d="m132.25 111.1c-79.72 21.39-130.23 91-112.82 155.46 12.84 47.53 60.35 78.99 115.88 83.66l132.14-218.63c-34.37-24.97-84.59-34.08-135.2-20.49z"
        fill="#efe6e4"
      ></path>
      <path
        d="m308.11 189.07a99.682 99.682 0 0 0 -12.09-27.43 110.228 110.228 0 0 0 -28.57-30.05c-65.57-19.3-147.21 5.65-180.74 79.29-42.86 94.1 42.87 136.63 48.6 139.34 4.57.39 9.2.59 13.86.61l158.98-109.99a.037.037 0 0 0 .01-.03c3.53-15.92 4.31-35.63-.05-51.74z"
        fill="#e0d7d5"
      ></path>
      <path
        d="m457.99 299.72a.077.077 0 0 1 -.01-.03c-3.13-17.46-23.11-29.64-50.22-33.25a138.333 138.333 0 0 0 -29.59-.59h-.01l-33.16 98.31a161.055 161.055 0 0 0 35.46-1.87c47.48-8.47 82.17-36.48 77.53-62.57z"
        fill="#efe6e4"
      ></path>
      <path
        d="m378.36 267.35-230.72 74.18a61.621 61.621 0 0 0 1.53 9.3c4.72 20.15 23.51 65.22 96.65 54.84 25.44-3.62 47.18-10.27 65.31-19.11a147.368 147.368 0 0 0 33.87-22.4c30.65-27.38 41.36-63.48 33.36-96.81z"
        fill="#dddcd4"
      ></path>
      <path
        d="m308.15 240.84c14.11-1.81 27.99-1.81 41.04.75a93.922 93.922 0 0 1 9.88 2.49 29.265 29.265 0 0 1 10.46 5.59 25.512 25.512 0 0 1 8.63 16.18c.08.5.14.99.2 1.5 3.56 34.23-41.79 92.65-118.47 106.59-75.51 13.74-108.12-4.24-112.25-32.41-2.31-15.83 5.25-31.48 18.61-40.33 26.24-17.38 85.87-53.16 141.9-60.36z"
        fill="#ebede4"
      ></path>
      <ellipse cx="285" cy="277.2" fill="#cbcebe" rx="3.59" ry="3.58"></ellipse>
      <path
        d="m49.43 266.56c-17.41-64.46 33.1-134.07 112.82-155.46a184.126 184.126 0 0 1 32.012-5.64 179.273 179.273 0 0 0 -62.012 5.64c-79.72 21.39-130.23 91-112.82 155.46 12.84 47.53 60.35 78.99 115.88 83.66l2.781-4.6c-43.312-11.132-77.982-39.529-88.661-79.06z"
        fill="#d8cdcb"
      ></path>
      <path
        d="m177.64 341.53c-2.31-15.83 5.25-31.48 18.61-40.33 26.24-17.38 85.87-53.16 141.9-60.36 1.215-.156 2.428-.293 3.639-.422a135.763 135.763 0 0 0 -33.639.422c-56.03 7.2-115.66 42.98-141.9 60.36-13.36 8.85-20.92 24.5-18.61 40.33 3.521 24.019 27.754 40.624 81.622 36.482-33.101-3.129-48.837-17.488-51.622-36.482z"
        fill="#cccec0"
      ></path>
      <g fill="#c6bebd">
        <path d="m121.635 246.847a6.878 6.878 0 1 1 6.881-6.878 6.887 6.887 0 0 1 -6.881 6.878z"></path>
        <path d="m164.953 174.754a7.4 7.4 0 1 1 7.4-7.4 7.411 7.411 0 0 1 -7.4 7.4z"></path>
        <path d="m183.636 235.381a7.168 7.168 0 1 1 7.172-7.168 7.178 7.178 0 0 1 -7.172 7.168z"></path>
        <path d="m241.152 173.354a6.7 6.7 0 1 1 6.7-6.7 6.708 6.708 0 0 1 -6.7 6.7z"></path>
        <path d="m282.605 218.959a7.189 7.189 0 1 1 7.193-7.188 7.2 7.2 0 0 1 -7.193 7.188z"></path>
        <path d="m133.655 303.216a7.193 7.193 0 1 1 7.2-7.193 7.2 7.2 0 0 1 -7.2 7.193z"></path>
      </g>
      <path
        d="m200.95 335.037a6.928 6.928 0 1 1 6.931-6.928 6.936 6.936 0 0 1 -6.931 6.928z"
        fill="#cbcebe"
      ></path>
      <path
        d="m251.622 353.864a8.652 8.652 0 1 1 8.659-8.651 8.666 8.666 0 0 1 -8.659 8.651z"
        fill="#cbcebe"
      ></path>
      <path
        d="m242.112 290.023a4.343 4.343 0 1 0 4.338 4.342 4.345 4.345 0 0 0 -4.338-4.342z"
        fill="#cbcebe"
      ></path>
      <path
        d="m294.565 309.222a4.555 4.555 0 1 0 4.551 4.554 4.557 4.557 0 0 0 -4.551-4.554z"
        fill="#cbcebe"
      ></path>
      <path
        d="m334.877 267.615a4.144 4.144 0 1 0 4.138 4.145 4.147 4.147 0 0 0 -4.138-4.145z"
        fill="#cbcebe"
      ></path>
      <path
        d="m394.924 325.557a4.74 4.74 0 1 0 4.736 4.74 4.743 4.743 0 0 0 -4.736-4.74z"
        fill="#cec2c0"
      ></path>
      <path
        d="m397.617 277.626a4.575 4.575 0 1 0 4.571 4.575 4.579 4.579 0 0 0 -4.571-4.575z"
        fill="#cec2c0"
      ></path>
      <path
        d="m432.207 293.692a4.166 4.166 0 1 0 4.16 4.165 4.167 4.167 0 0 0 -4.16-4.165z"
        fill="#cec2c0"
      ></path>
    </svg>
  ),
  butter: (props) => (
    <svg viewBox="0 0 68 68" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    d="m65.9146652 39.822876-.0077896 2.7486076c-.0133286 4.7001686-3.1025276 9.3932533-9.2737732 12.9795876-12.4222527 7.2190247-32.6271362 7.2191772-45.1306496.0002708-6.2892604-3.6311073-9.4306135-8.3982124-9.4171181-13.1584396l.0077841-2.7486038c-.0134871 4.760231 7.6737652 4.0434303 13.9630251 7.6745377 12.5035133 7.2189064 23.5441227 5.5892982 35.9663773-1.6297264 6.1712463-3.5863343 13.8788231-1.1660615 13.892144-5.8662339z"
                    fill="#e0e1ec"
                  ></path>
                </g>
                <g>
                  <path
                    d="m56.4938583 26.6611195c12.5035095 7.2189045 12.5692902 18.9223232.1470375 26.1413479s-32.62714 7.2191772-45.1306534.0002708c-12.4993076-7.2164764-12.5650797-18.919899-.1428251-26.1389256s32.6271353-7.2191734 45.126441-.0026931z"
                    fill="#edeef2"
                  ></path>
                </g>
                <g>
                  <path
                    d="m51.7389946 29.4243412c9.8469543 5.6851406 9.8990059 14.9325733.120327 20.6153202-9.7829475 5.6852303-25.7477989 5.6853065-35.5947571.000164-9.8427505-5.6827126-9.8947926-14.9301491-.1118431-20.6153793 9.7786789-5.6827469 25.7435226-5.6828194 35.5862732-.0001049z"
                    fill="#e0e1ec"
                  ></path>
                </g>
                <g>
                  <path
                    d="m59.0831528 40.9213142c-.4382744-3.3718491-2.893074-6.6762772-7.3438148-9.2523746-9.8458595-5.6781788-25.808136-5.6781788-35.5864944.0067501-4.3766527 2.5491371-6.7909489 5.8063126-7.2224731 9.1376991-.5530291-4.0799255 1.854517-8.2744865 7.2224731-11.39007 9.7783585-5.6849308 25.7406349-5.6849308 35.5864944 0 5.4487952 3.1425458 7.8968429 7.3776036 7.3438148 11.4979954z"
                    fill="#bdbdc6"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m52.1890526 40.6777878-17.3300781 10-21.9101553-12.7299805-.0598145-20.9100361 17.3298349-10 21.9201642 12.7300415z"
                  fill="#ffd86a"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m34.8637505 50.681778-21.9132719-12.7346001-.0592719-20.9072323 21.913271 12.734602z"
                  fill="#f7b92f"
                ></path>
              </g>
              <g>
                <path
                  d="m34.8044777 29.7745476-21.913271-12.734602 17.3298207-10.0053768 21.913269 12.734602z"
                  fill="#ffd86a"
                ></path>
              </g>
              <g>
                <path
                  d="m52.1342964 19.7691708.0592728 20.9072284-17.3298187 10.0053788-.0592728-20.9072304z"
                  fill="#fccb4f"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m57.128994 23.3178005-2.7600098 19.0100117-17.3400879 10.0099487-2.1599121-1.6599731 2.7700196-19.0100117 17.3298339-10z"
                  fill="#ffd86a"
                ></path>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  d="m37.0311661 52.3343582-2.1654701-1.6542625 2.7696914-19.0094834 2.1654701 1.6542626z"
                  fill="#f7b92f"
                ></path>
              </g>
              <g>
                <path
                  d="m39.8008575 33.3248749-2.1654701-1.6542626 17.3328209-10.0071087 2.1654701 1.6542607z"
                  fill="#ffd86a"
                ></path>
              </g>
              <g>
                <path
                  d="m57.1336784 23.3177643-2.7696914 19.0094833-17.3328209 10.0071106 2.7696914-19.0094833z"
                  fill="#fccb4f"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  eggs: (props) => (
    <svg
      height="512"
      viewBox="0 0 497 497"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m467 77.149c0-16.569-13.431-30-30-30h-377c-5.466 0-10.586 1.469-15 4.023l-5 257.31c0 16.569 13.431 30 30 30l395.526-5c1.095-4.414 1.474-9.534 1.474-15z"
          fill="#f2d1a5"
        ></path>
        <path
          d="m45 303.483v-252.31c-8.964 5.188-15 14.874-15 25.977v241.333c0 16.569 13.431 30 30 30l188.5 10 198.5-10c11.102 0 16.301-6.036 18.526-15h-390.526c-16.569 0-30-13.432-30-30z"
          fill="#d8ab8c"
        ></path>
        <path
          d="m432 246.166c0-3.978-1.58-7.794-4.394-10.607l-22.238-22.238c-5.858-5.858-5.858-15.355 0-21.213l5-5 7.238-7.238c2.814-2.812 14.394-16.628 14.394-20.606v-48.563c0-3.978-1.58-7.794-4.393-10.607l-13.552-13.552c-2.813-2.813-6.628-4.393-10.606-4.393h-48.563c-3.978 0-17.793 11.58-20.605 14.392l-7.239 7.239s-.001.001-.001.001l-4.999 4.999c-5.858 5.858-15.355 5.858-21.213 0l-22.238-22.238c-2.813-2.813-6.628-4.393-10.606-4.393h-48.965c-3.978 0-17.793 11.58-20.606 14.393l-12.238 12.238c-5.858 5.858-15.355 5.858-21.213 0l-22.238-22.238c-2.813-2.813-6.628-4.393-10.607-4.393h-48.566c-3.635 0-17.124 11.332-19.847 13.705-2.373 2.723-3.705 6.212-3.705 9.847v48.563c0 3.978 1.58 7.794 4.393 10.607l22.238 22.238c5.858 5.858 5.858 15.355 0 21.213l-15 15-7.238 7.238c-2.813 2.813-4.393 7.091-4.393 11.069v14.02 35.006c0 3.978 1.58 7.794 4.393 10.607l13.552 13.552c2.813 2.813 6.628 4.393 10.606 4.393h48.563c3.978 0 7.794-1.58 10.607-4.393l7.238-7.238 15-15c5.858-5.858 15.355-5.858 21.213 0l22.238 22.238c2.813 2.813 6.628 4.393 10.606 4.393h48.965c3.978 0 7.793-1.58 10.606-4.393l22.238-22.238c5.858-5.858 15.355-5.858 21.213 0l22.238 22.238c2.813 2.813 6.628 4.393 10.607 4.393h48.563c3.635 0 7.124-1.332 9.847-3.705 2.373-2.723 13.705-16.212 13.705-19.846v-49.49z"
          fill="#d8ab8c"
        ></path>
        <g fill="#c38778">
          <path d="m344.885 92.149c-3.978 0-7.793 1.58-10.605 4.392l14.999-14.999c2.813-2.813 6.628-4.393 10.607-4.393h48.563c3.978 0 7.793 1.58 10.606 4.393l13.552 13.552c2.813 2.813 4.393 6.628 4.393 10.607v48.563c0 3.978-1.58 7.794-4.393 10.607l-15 15c2.813-2.813 4.393-6.628 4.393-10.607v-48.563c0-3.978-1.58-7.794-4.393-10.607l-13.552-13.552c-2.813-2.813-6.628-4.393-10.606-4.393zm-222.77 0c3.978 0 7.794 1.58 10.607 4.393l22.238 22.238c5.858 5.858 15.355 5.858 21.213 0l22.238-22.238c2.813-2.813 6.628-4.393 10.606-4.393h48.965c3.978 0 7.793 1.58 10.606 4.393l22.238 22.238c5.858 5.858 15.355 5.858 21.213 0l14.999-14.999c-5.858 5.857-15.354 5.856-21.212-.001l-22.238-22.238c-2.813-2.813-6.628-4.393-10.606-4.393h-48.965c-3.978 0-7.793 1.58-10.606 4.393l-22.238 22.238c-5.858 5.858-15.355 5.858-21.213 0l-22.238-22.238c-2.813-2.813-6.628-4.393-10.607-4.393h-48.563c-3.978 0-7.793 1.58-10.606 4.393l-13.553 13.552c-.243.243-.464.503-.688.76 2.723-2.374 6.212-3.705 9.847-3.705zm273.254 109.96c-5.858 5.858-5.858 15.355 0 21.213l22.238 22.238c2.813 2.813 4.394 6.628 4.394 10.607v49.488c0 3.635-1.332 7.124-3.705 9.846.257-.224.517-.445.76-.688l13.552-13.552c2.813-2.813 4.393-6.628 4.393-10.607v-49.488c0-3.978-1.58-7.794-4.394-10.607l-22.238-22.238c-5.858-5.858-5.858-15.355 0-21.213z"></path>
          <path d="m154.959 254.246-30.924-30.924c-5.858-5.858-5.858-15.355 0-21.213l15-15c5.858-5.858 15.355-5.858 21.213 0l30.924 30.924c5.858 5.858 5.858 15.355 0 21.213l-15 15c-5.857 5.858-15.355 5.858-21.213 0z"></path>
          <path d="m290.827 254.246-30.924-30.924c-5.858-5.858-5.858-15.355 0-21.213l15-15c5.858-5.858 15.355-5.858 21.213 0l30.924 30.924c5.858 5.858 5.858 15.355 0 21.213l-15 15c-5.857 5.858-15.355 5.858-21.213 0z"></path>
        </g>
        <path
          d="m169.959 239.246-30.924-30.924c-5.858-5.858-5.858-15.355 0-21.213l30.924-30.924c5.858-5.858 15.355-5.858 21.213 0l30.924 30.924c5.858 5.858 5.858 15.355 0 21.213l-30.924 30.924c-5.857 5.858-15.355 5.858-21.213 0z"
          fill="#f2d1a5"
        ></path>
        <path
          d="m305.827 239.246-30.924-30.924c-5.858-5.858-5.858-15.355 0-21.213l30.924-30.924c5.858-5.858 15.355-5.858 21.213 0l30.924 30.924c5.858 5.858 5.858 15.355 0 21.213l-30.924 30.924c-5.857 5.858-15.355 5.858-21.213 0z"
          fill="#f2d1a5"
        ></path>
        <path
          d="m92.833 254.877c-5.046 0-9.951 1.105-14.652 3.111-23.782 19.509-38.181 59.226-38.181 85.495 0 41.636 28.131 71.368 62.833 71.368 8.787 0 25.91-7.206 34.743-15.436 11.183-12.615 18.091-30.31 18.091-50.933 0-41.636-28.132-93.605-62.834-93.605z"
          fill="#f7f9fa"
        ></path>
        <path
          d="m50 333.483c0-26.269 11.2-56.646 28.181-75.495-27.634 11.789-48.181 54.912-48.181 90.495 0 41.636 28.131 71.368 62.833 71.368 17.514 0 33.348-7.581 44.743-20.436-7.594 3.523-15.956 5.436-24.743 5.436-34.702 0-62.833-29.732-62.833-71.368z"
          fill="#dce6eb"
        ></path>
        <path
          d="m248.5 254.877c-5.046 0-9.951 1.105-14.652 3.111-23.782 19.51-38.181 59.226-38.181 85.495 0 41.636 28.131 71.368 62.833 71.368 8.787 0 25.91-7.206 34.743-15.436 11.183-12.615 18.091-30.31 18.091-50.933-.001-41.636-28.132-93.605-62.834-93.605z"
          fill="#f7f9fa"
        ></path>
        <path
          d="m205.667 333.483c0-26.269 11.2-56.646 28.181-75.495-27.634 11.789-48.181 54.912-48.181 90.495 0 41.636 28.131 71.368 62.833 71.368 17.514 0 33.348-7.581 44.743-20.436-7.594 3.523-15.956 5.436-24.743 5.436-34.702 0-62.833-29.732-62.833-71.368z"
          fill="#dce6eb"
        ></path>
        <path
          d="m404.167 254.877c-5.046 0-9.951 1.105-14.652 3.111-23.782 19.51-38.181 59.226-38.181 85.495 0 41.636 28.131 71.368 62.833 71.368 8.787 0 25.91-7.206 34.743-15.436 11.182-12.615 18.09-30.31 18.09-50.932 0-41.637-28.131-93.606-62.833-93.606z"
          fill="#f7f9fa"
        ></path>
        <path
          d="m361.333 333.483c0-26.269 11.2-56.646 28.181-75.495-27.634 11.789-48.181 54.912-48.181 90.495 0 41.636 28.131 71.368 62.833 71.368 17.514 0 33.348-7.581 44.743-20.436-7.594 3.523-15.956 5.436-24.743 5.436-34.701 0-62.833-29.732-62.833-71.368z"
          fill="#dce6eb"
        ></path>
        <path
          d="m158.739 407.644-9.638 23.564c-.519 1.268-1.129 2.478-1.801 3.643l-83.108 10-21.128-47.206zm39.991-10 21.128 47.206 83.108-10c.672-1.164 1.282-2.375 1.801-3.643l9.638-23.564zm155.667 0 21.128 47.206 83.108-10c.672-1.164 1.282-2.375 1.801-3.643l9.638-23.564z"
          fill="#d8ab8c"
        ></path>
        <path
          d="m371.966 426.15-7.57-18.506h105.675l9.089-22.22c1.717-4.199 5.803-6.942 10.339-6.942l-241-20-241 20c4.536 0 8.622 2.743 10.339 6.942l18.727 45.784c4.612 11.276 15.585 18.642 27.767 18.642h57c10.813 0 20.661-5.811 25.966-15h-73.707c-5.685 0-10.806-3.438-12.959-8.7l-7.569-18.506h93.747c5.692 0 9.567 5.772 7.412 11.04 6.021-14.72 26.866-14.72 32.887 0l5.123 12.524c4.612 11.276 15.585 18.643 27.767 18.643h57c10.813 0 20.661-5.811 25.966-15h-73.708c-5.686 0-10.806-3.438-12.959-8.701l-7.569-18.506h93.747c5.692 0 9.567 5.772 7.412 11.04 6.021-14.72 26.866-14.72 32.887 0l5.123 12.524c4.612 11.276 15.585 18.643 27.767 18.643h57c10.812 0 20.661-5.811 25.966-15h-73.708c-5.683 0-10.804-3.438-12.957-8.701z"
          fill="#c38778"
        ></path>
        <path
          d="m489.5 348.483h-469.5l-10 21 487-6v-7.5c0-4.143-3.358-7.5-7.5-7.5z"
          fill="#f2d1a5"
        ></path>
        <path
          d="m20 355.983v-7.5h-12.5c-4.142 0-7.5 3.358-7.5 7.5v15c0 4.142 3.358 7.5 7.5 7.5h482c4.142 0 7.5-3.358 7.5-7.5v-7.5h-469.5c-4.142 0-7.5-3.358-7.5-7.5z"
          fill="#d8ab8c"
        ></path>
      </g>
    </svg>
  ),
  honey: (props) => (
    <svg
      id="fi_3413290"
      height="512"
      viewBox="0 0 64 64"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m50.22 32.48-2.22-1.48-3 2v4l-3 2v4l-3 2v4l3 2v4l3 2v.7c-.15.28-.31.55-.47.82a6.933 6.933 0 0 1 -4.51 3.26 43 43 0 0 1 -8.02.99 43 43 0 0 1 -8.02-.99 6.933 6.933 0 0 1 -4.51-3.26 57.52 57.52 0 0 1 -3.69-7.37 1.427 1.427 0 0 0 .28-.58 1.5 1.5 0 0 0 -1.11-1.81l-.48-.11a4.967 4.967 0 0 0 -.32-3.24 1.5 1.5 0 0 0 .26-2.95l-1.46-.35 3.21-13.38c2.47.74 8.63 1.27 15.84 1.27 8.14 0 14.95-.67 16.61-1.57a19.32 19.32 0 0 1 1.61 4.05z"
        fill="#faa307"
      ></path>
      <path
        d="m43.78 56.19c-.3.56-.63 1.14-.97 1.72a5.009 5.009 0 0 1 -3.21 2.32c-.2.04-.41.08-.63.13a35.174 35.174 0 0 1 -13.94 0c-.22-.05-.43-.09-.62-.13a4.91 4.91 0 0 1 -2.39-1.29 35.1 35.1 0 0 0 8.98 1.06c5.08 0 8.88-1.72 11.58-4.61z"
        fill="#faa307"
      ></path>
      <path
        d="m43.78 56.19-1.2-.8c-2.7 2.89-6.5 4.61-11.58 4.61a35.1 35.1 0 0 1 -8.98-1.06 4.592 4.592 0 0 1 -.82-1.03c-6.11-10.38-6.87-18.02-5.76-23.36a3.586 3.586 0 0 1 3.98-2.79 110.4 110.4 0 0 0 12.58.64 110.4 110.4 0 0 0 12.58-.64 3.586 3.586 0 0 1 3.98 2.79c1.05 5.04.43 12.13-4.78 21.64z"
        fill="#ffba08"
      ></path>
      <path
        d="m24.473 45.562a16.412 16.412 0 0 1 -.516-10.124c1.164-4.357-5.586-6.216-6.749-1.861a23.032 23.032 0 0 0 .515 13.846c1.52 4.204 8.287 2.39 6.75-1.861z"
        fill="#f9cb70"
      ></path>
      <path
        d="m50.22 32.48-2.22-1.48-.94.63a18.586 18.586 0 0 0 -.94-2.52 9.127 9.127 0 0 0 2.49-.68 19.32 19.32 0 0 1 1.61 4.05z"
        fill="#f48c06"
      ></path>
      <path
        d="m45 57v.7c-.15.28-.31.55-.47.82a6.933 6.933 0 0 1 -4.51 3.26 43 43 0 0 1 -8.02.99 43 43 0 0 1 -8.02-.99 6.933 6.933 0 0 1 -4.51-3.26c-.1-.17-.2-.34-.29-.5a22.461 22.461 0 0 0 2.84.92 4.91 4.91 0 0 0 2.39 1.29c.19.04.4.08.62.13a35.174 35.174 0 0 0 13.94 0c.22-.05.43-.09.63-.13a5.009 5.009 0 0 0 3.21-2.32c.34-.58.67-1.16.97-1.72z"
        fill="#f48c06"
      ></path>
      <path
        d="m47.97 27.31c.22.35.44.73.64 1.12-1.66.9-8.47 1.57-16.61 1.57-7.21 0-13.37-.53-15.84-1.27l.37-1.56c2.68-.69 8.6-1.17 15.47-1.17 7.34 0 13.59.55 15.97 1.31z"
        fill="#ffba08"
      ></path>
      <path
        d="m43 22a17.035 17.035 0 0 1 4.97 5.31c-2.38-.76-8.63-1.31-15.97-1.31-6.87 0-12.79.48-15.47 1.17l.23-.97a16.384 16.384 0 0 1 4.24-4.2v-1.2c1.85.7 6.08 1.2 11 1.2s9.15-.5 11-1.2z"
        fill="#dcc"
      ></path>
      <path
        d="m44.375 25.118a108.889 108.889 0 0 0 -12.375-.618 108.53 108.53 0 0 0 -12.381.617 12.857 12.857 0 0 1 2.164-1.837l.712-.44v-.09a51.892 51.892 0 0 0 9.5.75 51.871 51.871 0 0 0 9.5-.749v.092l.72.438a13.015 13.015 0 0 1 2.16 1.837z"
        fill="#eaeaea"
      ></path>
      <path d="m51 33v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#ffba08"></path>
      <path
        d="m49.76 32.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#faa307"
      ></path>
      <path
        d="m48.26 33.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#ffba08"
      ></path>
      <path
        d="m48.39 33.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#f9cb70"
      ></path>
      <path d="m57 33v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#ffba08"></path>
      <path
        d="m55.76 32.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#faa307"
      ></path>
      <path
        d="m54.26 33.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#ffba08"
      ></path>
      <path
        d="m54.39 33.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#f9cb70"
      ></path>
      <path d="m48 39v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#ffba08"></path>
      <path
        d="m46.76 38.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#faa307"
      ></path>
      <path
        d="m45.26 39.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#ffba08"
      ></path>
      <path
        d="m45.39 39.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#f9cb70"
      ></path>
      <path d="m54 39v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#ffba08"></path>
      <path
        d="m52.76 38.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#faa307"
      ></path>
      <path
        d="m51.26 39.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#ffba08"
      ></path>
      <path
        d="m51.39 39.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#f9cb70"
      ></path>
      <path d="m60 39v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#ffba08"></path>
      <path
        d="m58.76 38.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#faa307"
      ></path>
      <path
        d="m57.26 39.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#ffba08"
      ></path>
      <path
        d="m57.39 39.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#f9cb70"
      ></path>
      <path d="m45 45v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m43.76 44.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m42.26 45.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m42.39 45.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m51 45v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m49.76 44.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m48.26 45.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m48.39 45.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m57 45v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m55.76 44.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m54.26 45.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m54.39 45.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m63 45v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m61.76 44.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m60.26 45.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m60.39 45.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m48 51v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m46.76 50.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m45.26 51.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m45.39 51.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m54 51v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m52.76 50.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m51.26 51.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m51.39 51.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m60 51v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m58.76 50.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m57.26 51.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m57.39 51.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m51 57v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m49.76 56.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m48.26 57.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m48.39 57.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m57 57v4l-3 2-3-2v-4l3-2 2.22 1.48z" fill="#faa307"></path>
      <path
        d="m55.76 56.18-1.5 1.12c-.44-.43-1.81.44-1.89 1.49-.04.51.26.66.63.58v2.96l-2-1.33v-4l3-2z"
        fill="#f48c06"
      ></path>
      <path
        d="m54.26 57.3-.86.65a1.014 1.014 0 0 0 -.4.8v.62c-.37.08-.67-.07-.63-.58.08-1.05 1.45-1.92 1.89-1.49z"
        fill="#faa307"
      ></path>
      <path
        d="m54.39 57.78a1.979 1.979 0 0 1 -1.39 1.59v-.62a1.014 1.014 0 0 1 .4-.8l.86-.65a.591.591 0 0 1 .13.48z"
        fill="#ffba08"
      ></path>
      <path d="m45 37v-2.135c-.17.829-.34 1.656-.512 2.476z" fill="#ffba08"></path>
      <path
        d="m43 19.2v1.6c-1.85.7-6.08 1.2-11 1.2s-9.15-.5-11-1.2v-3c1.85.7 6.08 1.2 11 1.2s9.15-.5 11-1.2z"
        fill="#eaeaea"
      ></path>
      <path
        d="m43 16.2v1.6c-1.85.7-6.08 1.2-11 1.2s-9.15-.5-11-1.2v-3.3c0 .83 4.92 1.5 11 1.5s11-.67 11-1.5z"
        fill="#dcc"
      ></path>
      <ellipse cx="32" cy="14.5" fill="#eaeaea" rx="11" ry="1.5"></ellipse>
      <path
        d="m22.59 2.66a1.982 1.982 0 0 1 .08 2.3l-1.33 2.14-3.89-.93-.22-2.51a1.9 1.9 0 0 1 2.35-2.12l1.95.47a1.951 1.951 0 0 1 1.06.65z"
        fill="#e0aa94"
      ></path>
      <path
        d="m-2.801 22.14h36.001v4h-36.001z"
        fill="#ffd5c2"
        transform="matrix(.233 -.973 .973 .233 -11.813 33.31)"
      ></path>
      <path
        d="m14.95 48.76a1.5 1.5 0 0 1 1.11 1.81 1.427 1.427 0 0 1 -.28.58 1.5 1.5 0 0 1 -1.18.57 1.447 1.447 0 0 1 -.35-.04l-.48-.12-9.73-2.33-.48-.11a1.5 1.5 0 0 1 .35-2.96 1.447 1.447 0 0 1 .35.04l.48.12 9.73 2.33z"
        fill="#ffd5c2"
      ></path>
      <path
        d="m6.48 43.58a1.5 1.5 0 0 1 .77-2.79 1.447 1.447 0 0 1 .35.04l1.46.35 3.89.93 1.46.35a1.5 1.5 0 0 1 -.26 2.95.277.277 0 0 1 -.09.01 1.393 1.393 0 0 1 -.35-.04l-6.81-1.63a1.944 1.944 0 0 1 -.42-.17z"
        fill="#ffd5c2"
      ></path>
      <path
        d="m13.56 54.6a1.5 1.5 0 0 1 -.34 2.95 1.472 1.472 0 0 1 -.36-.04l-.49-.12-9.72-2.32-.49-.12a1.5 1.5 0 0 1 .35-2.96 1.393 1.393 0 0 1 .35.04l.48.12 9.73 2.33z"
        fill="#ffd5c2"
      ></path>
      <g fill="#e0aa94">
        <path d="m14.15 45.41a4.967 4.967 0 0 1 .32 3.24l-9.73-2.33a5 5 0 0 1 1.74-2.74 1.944 1.944 0 0 0 .42.17l6.81 1.63a1.393 1.393 0 0 0 .35.04.277.277 0 0 0 .09-.01z"></path>
        <path
          d="m7.054 46.852h3.003v10.005h-3.003z"
          transform="matrix(.233 -.972 .972 .233 -43.866 48.086)"
        ></path>
        <path d="m16.06 50.57a1.427 1.427 0 0 1 -.28.58 1.5 1.5 0 0 1 -1.18.57 1.447 1.447 0 0 1 -.35-.04l-.48-.12-1.84-.44c.14-.97.27-1.96.4-2.98l2.14.51.48.11a1.5 1.5 0 0 1 1.11 1.81z"></path>
        <path d="m15.52 44.27a1.5 1.5 0 0 1 -1.37 1.14.277.277 0 0 1 -.09.01 1.393 1.393 0 0 1 -.35-.04l-1.01-.24.37-3 1.34.32a1.506 1.506 0 0 1 1.11 1.81z"></path>
        <path d="m14.66 56.41a1.5 1.5 0 0 1 -1.8 1.1l-.49-.12-1.46-.35c.19-.94.37-1.93.54-2.95l1.62.39.49.12a1.492 1.492 0 0 1 1.1 1.81z"></path>
      </g>
      <path
        d="m14.47 48.65-2.14-.51c.03-.24.06-.47.09-.71l.28-2.29 1.01.24a1.393 1.393 0 0 0 .35.04.277.277 0 0 0 .09-.01 4.967 4.967 0 0 1 .32 3.24z"
        fill="#d58936"
      ></path>
      <path d="m13.77 51.56-.7 2.92-1.62-.39q.24-1.44.48-2.97z" fill="#d58936"></path>
      <path
        d="m12.37 57.39v.01l-.23.97a5.005 5.005 0 0 1 -1.1 2.12 1.54 1.54 0 0 0 -.83-.52l-6.8-1.63a1.472 1.472 0 0 0 -.36-.04 1.6 1.6 0 0 0 -.62.13 5.076 5.076 0 0 1 -.02-2.39l.24-.97z"
        fill="#e0aa94"
      ></path>
      <path
        d="m12.37 57.39v.01l-.23.97a5.005 5.005 0 0 1 -1.1 2.12 1.548 1.548 0 0 0 -.77-.5c.22-.94.44-1.92.64-2.95z"
        fill="#d58936"
      ></path>
      <path
        d="m11.04 60.49a1.459 1.459 0 0 1 .28 1.28 1.508 1.508 0 0 1 -1.81 1.11l-6.8-1.63a1.49 1.49 0 0 1 -1.11-1.81 1.514 1.514 0 0 1 .83-1.01 1.6 1.6 0 0 1 .62-.13 1.472 1.472 0 0 1 .36.04l6.8 1.63a1.54 1.54 0 0 1 .83.52z"
        fill="#ffd5c2"
      ></path>
      <path
        d="m22.67 4.96-1.33 2.14-1.52-.36.15-.64 1.33-2.14a2.04 2.04 0 0 0 .13-1.97l.1.02a1.951 1.951 0 0 1 1.06.65 1.982 1.982 0 0 1 .08 2.3z"
        fill="#d58936"
      ></path>
      <path
        d="m21.34 7.1-8.39 35.01c-.02-.01-1.522-.364-1.522-.364l8.392-35.006z"
        fill="#efa88f"
      ></path>
      <path
        d="m11.32 61.77a1.508 1.508 0 0 1 -1.81 1.11l-6.8-1.63a1.482 1.482 0 0 1 -1.05-.92l6.48 1.55a1.508 1.508 0 0 0 1.81-1.11 1.429 1.429 0 0 0 -.05-.87l.31.07a1.54 1.54 0 0 1 .83.52 1.459 1.459 0 0 1 .28 1.28z"
        fill="#efa88f"
      ></path>
      <path
        d="m43 19.477a.478.478 0 0 0 -.5.477s-.084.157-.615.384c-1.684.7-5.66 1.162-9.893 1.162s-8.209-.467-9.887-1.16a3.681 3.681 0 0 1 -.613-.347.5.5 0 0 0 -1 .007c0 .739.918 1.131 1.226 1.262 1.829.752 5.862 1.238 10.282 1.238s8.453-.486 10.28-1.24c.3-.129 1.22-.521 1.22-1.26a.517.517 0 0 0 -.5-.523z"
        fill="#c1aeae"
      ></path>
      <path
        d="m21.726 18.262c1.821.752 5.854 1.238 10.274 1.238s8.453-.486 10.28-1.24c.3-.129 1.22-.521 1.22-1.26a.517.517 0 0 0 -.5-.523.478.478 0 0 0 -.5.477s-.084.157-.615.384c-1.684.7-5.66 1.162-9.893 1.162s-8.209-.467-9.887-1.16a2.862 2.862 0 0 1 -.613-.347.5.5 0 0 0 -1 .007c.008.739.926 1.131 1.234 1.262z"
        fill="#c1aeae"
      ></path>
      <path
        d="m19.064 31.808c-2.412.9-2.543 6.285-.128 5.384s2.543-6.285.128-5.384z"
        fill="#f7da9a"
      ></path>
      <path d="m18.152 38.1a1 1 0 0 0 0 2 1 1 0 0 0 0-2z" fill="#f7da9a"></path>
    </svg>
  ),
  cream: (props) => (
    <svg enable-background="new 0 0 468 468" viewBox="0 0 468 468" {...props}>
      <g>
        <g>
          <path
            d="m423.091 5.997c-12.953-10.088-31.769-7.125-40.968 6.458-34.44 50.854-71.716 105.327-105.02 154.731l23.921 18.631c40.174-44.005 84.315-93.074 125.629-138.534 11.07-12.179 9.428-31.169-3.562-41.286z"
            fill="#b76c4f"
          ></path>
          <path
            d="m423.091 5.997c-6.409-4.991-14.253-6.783-21.657-5.678 14.793 9.237 17.649 30.035 5.833 42.877-39.313 43.258-81.178 89.774-119.757 132.095l13.515 10.526c40.174-44.005 84.315-93.074 125.629-138.534 11.069-12.179 9.427-31.169-3.563-41.286z"
            fill="#ad6149"
          ></path>
        </g>
        <g>
          <path
            d="m34 272.418v6.413c0 104.475 84.943 189.169 189.726 189.169 104.783 0 189.726-84.694 189.726-189.169v-6.413z"
            fill="#ffb966"
          ></path>
          <path
            d="m223.726 447.563c-100.052 0-182.009-77.22-189.207-175.146h-.519v6.413c0 104.476 84.943 189.17 189.726 189.17 104.783 0 189.726-84.694 189.726-189.17v-6.413h-.52c-7.197 97.927-89.154 175.146-189.206 175.146z"
            fill="#f2a85f"
          ></path>
        </g>
        <g>
          <g>
            <path
              d="m223.813 354.528c102.168 0 185.462-35.511 189.578-79.997-.196-5.438-.376-9.973-.388-11.729 0-33.937-22.248-62.5-52.521-71.079 2.241-46.494-40.287-84.077-84.365-75.151-6.897-53.929-54.706-79.391-103.891-73.407-.757 94.237-73.752 77.732-90.969 138.743-27.229 10.418-46.634 37.437-46.634 69.136-.036 5.037-.563 20.036-.563 20.036.001 46.087 84.956 83.448 189.753 83.448z"
              fill="#ededed"
            ></path>
            <path
              d="m412.879 258.673c-8.097 42.806-89.638 76.44-189.066 76.44-100.521 0-182.772-34.376-189.318-77.854-.167 6.201-.434 13.821-.434 13.821 0 46.087 84.955 83.448 189.752 83.448 102.168 0 185.462-35.511 189.578-79.997-.196-5.438-.376-9.973-.389-11.729.001-1.387-.05-2.761-.123-4.129z"
              fill="#e0e0e0"
            ></path>
          </g>
          <g fill="#e0e0e0">
            <g>
              <path d="m83.25 185.726c30.003 1.37 54.335 30.251 50.36 60.08-.312 2.805 1.705 5.332 4.506 5.644 2.75.32 5.335-1.698 5.635-4.512 4.762-35.651-24.497-70.114-60.366-71.444-.778 2.043-1.495 4.17-2.128 6.413-2.405.921-4.745 1.977-7.02 3.147.184.034 9.013.672 9.013.672z"></path>
              <path d="m273.041 115.175c-8.23 24.044-37.118 37.194-60.677 27.762-2.639-.995-5.579.345-6.569 2.988-.99 2.641.346 5.587 2.984 6.578 29.936 12.045 66.176-6.042 75.016-37.019-2.548.212-5.11.567-7.677 1.087-.276-2.16-.625-4.269-1.03-6.338-.689.757-1.644 3.983-2.047 4.942z"></path>
              <path d="m291.006 215.295-3.884-1.353c-2.664-.925-5.57.481-6.495 3.147-.926 2.664.481 5.577 3.142 6.504 30.731 12.777 67.648.654 83.648-29.486-2.261-.908-4.57-1.713-6.936-2.384.103-2.142.11-4.265.027-6.366-12.139 26.403-41.845 39.614-69.502 29.938z"></path>
            </g>
            <g>
              <ellipse cx="216.296" cy="109.448" rx="8.787" ry="10.953"></ellipse>
              <ellipse cx="178.734" cy="299.421" rx="8.787" ry="10.953"></ellipse>
              <ellipse cx="310.893" cy="293.248" rx="8.787" ry="10.953"></ellipse>
              <ellipse cx="297.825" cy="187.208" rx="8.787" ry="10.953"></ellipse>
              <ellipse cx="187.521" cy="227.611" rx="8.787" ry="10.953"></ellipse>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  mascarpone: (props) => (
    <svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" {...props}>
      <g>
        <path
          d="m111.3 157.3c-30.8 22-43.9 61.3-32.4 97.4l5.3 16.5 133.7 20.7-86.7-148.7z"
          fill="#e3eaee"
        ></path>
        <path
          d="m421.4 173.6c-9.7-12.7-23.2-21.8-38.4-26.8-14.6-4.8-36.3-17.3-42.6-50.3-9.1-47.7-85.6-96.5-85.6-96.5l-18.4 194.9 117.1 81.3 71.9-5c19.3-37.6 13-75.4-4-97.6z"
          fill="#d9e1e8"
        ></path>
        <path
          d="m84.1 337.7v11.9c0 29.3 10.5 57.6 29.6 79.8 19.1 22.2 29.6 50.5 29.6 79.8v2.8h111.5l8.5-90.8-8.5-83.5-81.1-17.9z"
          fill="#d0e8ff"
        ></path>
        <path
          d="m254.8 512h111.4v-2.8c0-29.3 10.5-57.6 29.6-79.8 19.1-22.2 29.6-50.5 29.6-79.8v-11.9l-89.1-10-81.5 10z"
          fill="#9dcfff"
        ></path>
        <path
          d="m275.2 146.9c-14.3-23.6-20-51.3-20.4-90.6l-27 132.5 27 82.4 38.4 20.7 60.4-15.7z"
          fill="#e3eaee"
        ></path>
        <path
          d="m254.8 0s-2.4 2.8-5.9 6.8c-14.7 16.9-33 30.3-53.8 39.1l-.9.4c-23.9 10.1-43.1 28.9-53.7 52.6l-.5 1c-13.1 29.4-12 63.2 3.1 91.7l50.5 95.1 34.9-2.3 26.3-13.1z"
          fill="#f5f8f9"
        ></path>
        <path d="m254.8 271.2h-170.7v66.5h170.7l8.5-37.1z" fill="#9dcfff"></path>
        <path d="m254.8 271.2h170.6v66.5h-170.6z" fill="#72bbff"></path>
      </g>
    </svg>
  ),
  'whipped-cream': (props) => (
    <svg
      enable-background="new 0 0 396.987 396.987"
      viewBox="0 0 396.987 396.987"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <g fill="#f3efee">
          <path d="m213.688 116.251h114.098v280.737h-114.098z"></path>
          <path d="m213.688 246.619h114.098v150.368h-114.098z"></path>
          <path d="m327.786 116.251h-114.098v-82.539l20-33.712h74.098l20 33.712z"></path>
        </g>
        <path d="m327.786 241.036-114.098 50v-88.77l114.098-50z" fill="#dd455b"></path>
        <path d="m327.786 290.972-114.098 50v-25.854l114.098-50z" fill="#dd455b"></path>
        <path
          d="m69.202 286.133c0 39.508 32.027 71.535 71.535 71.535h15.743v39.319h8.321v-39.319h15.743c39.508 0 71.535-32.027 71.535-71.535z"
          fill="#c3c6d4"
        ></path>
        <path d="m148.754 339.668h10.726v6h-10.726z" fill="#fff"></path>
        <path
          d="m180.543 345.668h-12.857v-6h12.857c24.017 0 45.245-16.174 51.624-39.332l.796-2.892 5.785 1.593-.797 2.893c-7.093 25.752-30.7 43.738-57.408 43.738z"
          fill="#fff"
        ></path>
        <path
          d="m218.495 286.133h-142.413c0-14.748 11.955-26.703 26.703-26.703h142.414c-.001 14.747-11.956 26.703-26.704 26.703z"
          fill="#ffe0b3"
        ></path>
        <path
          d="m245.198 259.43h-114.921c-14.748 0-26.703-11.955-26.703-26.703h114.921c14.748 0 26.703 11.955 26.703 26.703z"
          fill="#ffebd7"
        ></path>
        <path
          d="m178.419 232.727h-74.845c0-14.748 11.955-26.703 26.703-26.703h74.845c0 14.748-11.955 26.703-26.703 26.703z"
          fill="#ffe0b3"
        ></path>
        <path
          d="m205.122 206.024h-42.17c-14.748 0-26.703-11.955-26.703-26.703h42.17c14.748 0 26.703 11.955 26.703 26.703z"
          fill="#ffebd7"
        ></path>
        <path d="m213.688 100.914h114.098v15.337h-114.098z" fill="#5a617a"></path>
        <path
          d="m259.327 100.914h-22.82v-57.399c0-5.414 4.389-9.802 9.802-9.802h3.215c5.414 0 9.802 4.389 9.802 9.802v57.399z"
          fill="#c3c6d4"
        ></path>
        <path
          d="m304.966 100.914h-22.82v-57.399c0-5.414 4.389-9.802 9.802-9.802h3.215c5.414 0 9.802 4.389 9.802 9.802v57.399z"
          fill="#c3c6d4"
        ></path>
        <path
          d="m129.914 396.987c0-7.042 5.709-12.751 12.751-12.751h35.949c7.042 0 12.751 5.709 12.751 12.751z"
          fill="#5a617a"
        ></path>
      </g>
    </svg>
  ),
  cheese1: (props) => (
    <svg
      id="fi_9691379"
      enable-background="new 0 0 38 38"
      height="512"
      viewBox="0 0 38 38"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="_x33_5">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="m29.8996735 23.2491302c0 .2247372-.2058029.4639835-.4699707.4399414-.1002789-.0047512-13.1521149-.6261768-12.7800293-.6099854-.4231434 0-.3154202.4698696-.3300171.5699463.0197411.6253204-.0525093-1.6040401.2200317 6.8100586-.0180187.1001911.0581226.3130894-.2200317.4799805-.5681906.2843857-10.7597103-.2909813-12.9499512-5.1099854-.5171309-.9767628-.3175514-1.5449352-.3500366-13.4799795h10.75v5.4499502c4.9744072-.4316387 12.7557945.3004551 15.6099854 4.3800049.1368255.1915646.5200195.8365193.5200195 1.0700684z"
                  fill="#aa6256"
                ></path>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      d="m14.4897003 30.9190521c-1.6909666-.133625-1.1283007-.1398926-1.4200439-.1398926-3.5700073-1.25-6.8200068-2.9400635-9.6999512-4.9500732-.0900269-.1700439-.1500244-.3399658-.2000122-.5200195 3.2899785 2.3599853 7.0999756 4.290039 11.3200073 5.6099853z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.5496979 30.5391693c0 .0098877 0 .0198975-.0100098.0299072-5.1300049-1.3499756-9.7000122-3.6199951-13.5200195-6.4699707v-.3800048c3.7999878 2.8800049 8.3699951 5.1599121 13.5100098 6.5300293l.0100098.2099609z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.499649 29.299057c-5.1599731-1.4000244-9.7199707-3.7598877-13.4799805-6.6999512v-.3699951c3.75 2.9599609 8.2999878 5.3399658 13.4700317 6.75z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.459671 27.7090912v.3300781c-5.1900024-1.460083-9.7399902-3.9101563-13.4400024-6.9500732v-.3900146c3.6799931 3.0700683 8.2299804 5.5500487 13.4400024 7.0100097z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.419693 26.6790619v.0900879c-5.2300415-1.5200195-9.7700195-4.0700684-13.4000244-7.2200928v-.3800049c3.6000366 3.1700439 8.1500244 5.75 13.3900146 7.2900391z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.3796539 25.5191498c-5.2799683-1.5900879-9.8199463-4.2700195-13.3599854-7.5300293v-.4000244c3.5200195 3.2999268 8.0599976 6 13.3500366 7.6099854z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.3396759 24.1490326v.1101074c-5.3400269-1.6600342-9.8800049-4.4699707-13.3200073-7.8601074v-.3999014c3.4199829 3.4199209 7.9600215 6.2600088 13.3099976 7.9399405z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m17.8196564 23.1290131c-.6985931-.0298576-1.2725716-.05439-1.1699829-.0499268-.0200195 0-.039978 0-.0599976.0100098-5.5299683-1.7299805-10.1699829-4.7299805-13.5700073-8.3199453v-.4100342c3.6199956 3.9000234 8.7000122 7.1099844 14.7999878 8.7698965z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m29.8796539 23.3591156c-11.6499633.8900146-21.2699585-3.8399658-26.8599848-10.2700186v-.4200439c5.5200191 6.4799795 15.1500244 11.2900381 26.8300171 10.3900137.0100098.0100098.0100098.0300293.0200195.0400391.0310397.0776462.0449652.1899795.0099482.2600097z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m29.3796539 22.1790619c-11.0599976.75-20.1799927-3.7399902-25.5299683-9.8299551h.3699951c5.2899776 5.8900137 14.1699829 10.2199697 24.9400024 9.5499258.0800172.0900879.1500245.1800537.2199708.2800293z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m28.3396759 21.0391693c-9.789978.4099121-17.9099731-3.420166-22.9899902-8.6900625h.3900146c4.9899898 5.0599356 12.8200073 8.70996 22.25 8.4000235.1199951.0999755.2399903.1899414.3499756.290039z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
              </g>
              <g>
                <path
                  d="m29.9000244 11.2925949v11.956646c0 .2417946-.2065411.4546223-.4697571.4420319-1.3067055-.0625916 4.7329407.2267113-12.7777557-.6120605-.1876469-.0088253-.113348-4.4292622-.113348-4.4292622-.0137272-.1003838-1.2391958-9.0614853-1.1611528-8.4908047 11.2765779.8798551-13.1660269-1.0284615 14.5220136 1.1334495z"
                  fill="#ffde9b"
                ></path>
              </g>
              <g opacity=".3">
                <path
                  d="m28.8030949 11.2069502c-.2753601 2.7552681-9.400423 2.0603323-13.3873034-1.0452995z"
                  fill="#fafdfc"
                ></path>
              </g>
              <g>
                <path
                  d="m29.9003868 12.0072708v11.2425518c0 .2418098-.206543.4546375-.4697571.4420471l-12.7777557-.6120605c-.1876488-.0088253-.113348-4.4292622-.113348-4.4292622l-1.0729952-7.8472595 1.2140455.049118c-.3249168.7392607-.0793419 1.5994177.2481041 2.3374186.3261776.7380152.7405205 1.4747391.7518501 2.2820272.0088177.7480698-.3324795 1.4860687-.2153492 2.2240696.1108265.693924.6183567 1.3135338.5692387 2.0150223-.0251904.3538952-.1926823.6800728-.2783203 1.0251446-.0868988.343811-.0705261.7581539.1989784.9898777.1498661.1284599.3513737.1763172.5440559.2203941.4735317.1070442.978548.2140884 1.4369678.0528831.2292099-.0793266.4344826-.2228985.6687355-.2808399.8903885-.2191334 1.6586132.8299484 2.5741901.79216.6284351-.0251827 1.1435204-.5604229 1.7707005-.6070194.4634552-.0340061.8966846.2052822 1.3223591.3941898.5956879.2657299 1.2606487.4470882 1.9004135.3148479.6397724-.1322422 1.2316856-.6498489 1.2770214-1.3009586.028965-.4231529-.164978-.8311939-.1813507-1.2543468-.0201473-.482357.1901684-.9407597.2745457-1.4142914.2430611-1.3551044-.5415363-2.7114687-.4307098-4.0841904.0705262-.8790663.5037556-1.7140416.7883797-2.5515231z"
                  fill="#ffd475"
                ></path>
              </g>
              <g>
                <path
                  d="m29.4264908 11.7167282c-.1530228-.0083542-12.5879478-.6077471-12.6500244-.6098633-.1337318.0330753-.4500122-.0587912-.4500122.289917-.0175896.0175896-.0110798.0878239 0 .1099854 0 .1300049.0400391 1.1899414.2200317 7.0500488 0 .25-.2000122.4599609-.4500122.4599609h-.0599976c-3.8464937 0-7.4544621-.9995728-10.4100342-2.8000488-.1453781-.0968533-.7193437-.4518814-.9899902-.6999512-1.2299802-1.2299805-2.1199949-2.9000244-1.3999631-4.3499756.8699949-2.4500732 4.3399658-4.0500493 6.8599854-4.6800542 5.2209558-1.4855576 15.1364651-1.0551262 18.8999634 3.3400884.4400024.4699707.75.9199219.8700562 1.289917.109985.3000489-.1200565.6099854-.4400028.5999756z"
                  fill="#dba660"
                ></path>
              </g>
              <g>
                <path
                  d="m16.5458202 18.5598602c.0075569.2531376-.1964645.4647217-.4495945.4596806-9.9986076 0-17.4102325-6.1443319-10.2942524-10.7173977.4846106-.3111591 1.0653854-.6180267 1.3941451-.7657027-1.2769518 1.6124997-1.53022 3.4627194-.5642037 5.3838878 1.6168628 3.2240829 5.3883414 5.5426693 9.8987942 5.1723042.0175566.5748671.009683.3018798.0151113.4672278z"
                  fill="#bf7d5a"
                ></path>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      d="m6.5796666 7.8491063-3.5199585 3.9899907c.0197942-.2188292.1254764-.5610113.1799927-.6700439l2.5-2.8299561c.0199585-.0100098.039978-.0300293.0599976-.0400391.1002182-.0584182.5086822-.3144268.7799682-.4499516z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m9.1396637 6.77916-5.9299922 6.6999516c-.039978-.1101074-.0700073-.2299805-.0899658-.3400879l5.4499507-6.1699224c.1900024-.0700682.3699951-.1300048.5700073-.1899413z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m11.2397003 6.2191014-7.4200435 8.3999023c-.0255339-.0253773-.1582456-.2130814-.1699829-.2598877l7.0999751-8.0300293c.0966464-.0276369.4836274-.1078438.4900513-.1099853z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m13.1296539 5.8990331-8.4899902 9.6201172c-.1083093-.1084194-.138341-.1184435-.2299805-.210083l8.2700195-9.3499756c.0299683 0 .0499878-.0100098.0799561-.0100098.1199951-.0200195.25-.0300293.3699951-.0500488z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m14.8996735 5.7291112-9.3099971 10.5400386c-.0286422-.0286407-.2165418-.157793-.25-.1800537l9.1300049-10.3299561c.0347266-.00316.3999934-.0200085.4299922-.0300288z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.5064468 5.7367473c-1.1399879 1.2889881 3.8739262-4.3802595-9.8699951 11.1600342-.1317863-.0791683-.2650962-.1551418-.2699585-.1600342 13.5350132-15.3174477 8.5973339-9.7295227 9.7199707-11z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m18.0664444 5.7867961c-1.1884956 1.3455682 4.0387669-4.5725307-10.289978 11.6499023-.0999756-.039917-.1900024-.0898438-.289978-.1298828 14.1895294-16.0694488 9.0130767-10.2071876 10.1900024-11.540039.0210857.000812.3348846.0157795.3899536.0200195z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m19.5664444 5.9067912c-2.111763 2.3892102 5.4580288-6.1751146-10.5799561 11.9699707-.0358191 0-.273984-.0909595-.3099976-.0999756 14.6629296-16.5846653 9.313778-10.5344491 10.5299683-11.9100342.1113072.0139275.1277981.0206705.3599854.0400391z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m21.0064468 6.0968547c-.6283932.7330194-9.7422504 11.0322514-10.7399902 12.1599121-.0200195 0-.2999878-.0799561-.3300171-.0899658 16.4397717-18.569355 8.452776-9.5477352 10.7300415-12.1199951.1099854.0200195.2299805.0300293.3399658.0500488z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.3596954 12.7391214.0100098.3599854v.0899658l-4.75 5.3699942c-.0416842 0-.3093462-.0608978-.3500366-.0699463z"
                      fill="#aa6256"
                    ></path>
                  </g>
                  <g>
                    <path
                      d="m22.0464649 6.2967963-4.3000011 4.8600002.3199997.0099992h.0799999l4.2400017-4.7999997z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.4297028 14.9390726-3.4100342 3.8500967c-.0499878-.0100098-.0999756-.0100098-.1499634-.0200195-.1004372 0-.1587105-.0300293-.210022-.0300293l3.7600098-4.2399893c.0022907.100667.0123005.5406084.0100098.4399414z"
                      fill="#aa6256"
                    ></path>
                  </g>
                  <g>
                    <path
                      d="m23.709671 6.6890721-4.0299683 4.5600591-.1600342-.0100098h-.2199707l4.0999756-4.6400151c.0200195 0 .0300293 0 .0499878.0100098.0403252.0079765.2332421.0732541.2600098.079956z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.4696808 16.2491302.0200195.4399414-1.9900513 2.25c-.1299438 0-.2599487-.0100098-.3799438-.0300293z"
                      fill="#aa6256"
                    ></path>
                  </g>
                  <g>
                    <path
                      d="m24.9496613 7.1190038-3.7199707 4.2100835-.3800049-.0300293 3.789978-4.2899175c.1099853.0300293.210022.0699463.3099976.1098633z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m16.5296783 18.0890961.0100098.1500244v.2099609l-.5.5700684c-.0411615 0 .1133232.0033379-.3800049-.0100098l.8699951-.9899902z"
                      fill="#aa6256"
                    ></path>
                  </g>
                  <g>
                    <path
                      d="m26.1096954 7.6290135-3.3300171 3.77002h-.0300293l-.1599731-.0100098-.1900024-.0100098 3.4400024-3.8798833c.0425301.0085163.2072029.0914574.25.119873.0100098.0000002.0100098.0100099.0200195.0100099z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m26.9164639 8.0867958-2.9699994 3.3600006.0599995.0100002h.0300007l.289999.0099993 2.8400002-3.21z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m28.126442 8.9867477-2.2599487 2.5600586h-.0500488l-.3299561-.0200195 2.4099731-2.7299805c.0800171.0600586.1599731.1300049.2299805.1899414z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m28.9964371 9.8268356-1.5799561 1.789917-.1500244-.0098877h-.2399902c.3248234-.3670292 1.8684254-2.1111927 1.7700195-2 .0700073.0699463.1399536.1499024.1999512.2199707z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m29.7397003 10.8190775-.7700195.8800049-.3200073-.0200195h-.0700073l1.0100098-1.1499023c.0499877.0998534.1099853.1899413.1500243.2899169z"
                      fill="#aa6256"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
            <g opacity=".5">
              <path
                d="m29.9000244 13.4562321v9.7930088c0 .2417946-.2065411.4546223-.4697571.4420319l-10.7954788-.5176068 1.3126965-6.7489662c.0367374-.1888809.177866-.3403358.3636875-.3902988z"
                fill="#f3a250"
              ></path>
            </g>
            <g>
              <g>
                <path
                  d="m34.9964638 17.8265133c-.04039.5377274-.9277802 12.352087-.9357262 12.4578648h-.0050354c-.0289688.5755501-.1863937 1.1699772-.4697571 1.7732315-.080677.167572-.2667274.2585411-.4470787.21661-12.7722034-2.9864521-12.2950439-2.7032604-12.3042336-2.9419308-.0019455-19.6593876-.0009823-9.9221668-.0012608-12.737463.1056596.0091896-1.4085768-.1224957 14.1630918 1.2316875z"
                  fill="#ffde9b"
                ></path>
              </g>
              <g>
                <path
                  d="m34.8755608 19.4397964-.8148232 10.8445816h-.0050354c-.0289688.5755501-.1863937 1.1699772-.4697571 1.7732315-.080677.167572-.2667274.2585411-.4470787.21661-12.7722034-2.9864521-12.2950439-2.7032604-12.3042336-2.9419308-.0019455-18.6291752-.0009823-9.4022141-.0012608-12.0699806 1.2215691 1.8643341.5468941 2.4058151.5251713 3.1195107-.0226688.7430267.6485806 1.3752422.6170959 2.1170235-.0188866.4433079-.2896576.8475666-.3009949 1.2908745-.0151119.5516129.371521 1.0629311.3211498 1.612009-.0214157.2317371-.1196442.448349-.1939507.6687431-.193943.5667248-.2342453 1.2052422-.0075569 1.7618828.2254353.5553951.7455635 1.0075111 1.3437748 1.0578899.5579071.0465965 1.1624126-.2380257 1.6573524.0239372.2619553.1385136.4344902.4067802.6888809.5591602.7556343.4508705 1.8009319-.2984734 2.5804939.1108265.4584122.2405491.772007.8576374 1.2845707.7871189.1977253-.0277176.3627052-.1599445.533989-.2644691.7934132-.4861374 1.9041939-.3778172 2.589304.2531395 1.3415527-2.325388.3392487-2.7579842.1208954-3.2731514-.3740349-.876545.8941689-1.7153034.7657089-2.6598434-.0743065-.5427895-.608284-1.0301723-.430706-1.5477791.0642281-.1889095.2128372-.3324814.3312187-.4924259.6687355-.9017105.3135872-2.1674042-.0667534-3.2240334.5642054.0188942 1.1762736.0591889 1.682545.2770748z"
                  fill="#ffd475"
                ></path>
              </g>
              <g>
                <path
                  d="m34.9964638 17.8265133-.9357262 12.4578648h-.0050354c-.0289688.5755501-.1863937 1.1699772-.4697571 1.7732315-.0327454.0680122-.0818558.1221542-.1410484.1612053.5818367-2.8537807.9823227-12.5813007.9823227-12.5813007l-.3261795-1.889082z"
                  fill="#8a4852"
                ></path>
              </g>
              <g>
                <path
                  d="m34.959671 18.1390228c0 .1000366-.2165337.9131699-.4500122 1.380127-.044014.1101074-.0941658.1327229-.1799927.1899414-.2218361.1234093-.3964119.0135365-.5100098 0-.1024513-.0241299-.9523697-.2243137-.8499756-.1999512-.1000023-.0227318-.7599754-.1727562-.6599731-.1500244-.1000366-.0223465-1.1300678-.252449-1.0300293-.2301025-.1000271-.0230675-.7500515-.1729698-.6500244-.1499023-.1026096-.0234451-1.9802151-.4524593-1.8800049-.4300537-.1024075-.024313-.9023972-.2142429-.7999878-.1899414-.100008-.0224819-.9899616-.2225552-.8899536-.2000732-.9449253-.2170944-2.8402081-.6525288-2.7400513-.6298828-.3472347-.0818729-.9700699-.2287865-.8499756-.2000732-.1000614-.0222378-.7300663-.1622524-.6300049-.1400146-1.4138336-.3287239-1.25144-.2846737-1.2299805-.2800293l-.0300293-.0100098-.3300171-.0699463-.2799681-.0699465c-.1699829-.0400391-.1799927-.2800293-.0200195-.3300781.2339668-.0760098 1.0378513-.3370419.9200439-.3000488 1.2307262-.422039.6357918-.2251835 2.289978-.7600088l.2000122-.0699463.1300049-.0499268c.6167336-.2033577 2.0429993-.6743431 1.9400024-.6400146.1303463-.0433044.6755009-.2244339.5699463-.1900635.1000004-.0336113 4.5222435-1.5039654 4.2400513-1.4099121h.0199585l.0500488-.0200195c.0599976-.0200195.1299438-.0300293.1999512-.0100098.0400391 0 .0800171.0100098.1199951.0300293 2.4172173 1.205843 3.3800049 2.8823853 3.3800049 4.249999.0443459.265522-.0499878.7751541-.0499878.8798828z"
                  fill="#dba660"
                ></path>
              </g>
              <g>
                <path
                  d="m34.6148643 19.2785912c-.0603714.148613-.1146812.2859573-.187645.358923-.0932732.097332-.2477913.1519146-.3979645.1171303-.1003456-.0231571-12.9680061-2.9771042-12.4163208-2.848753 1.0944099-.0566654 2.2127476-.0805874 3.2378922.2972298.4382648.16119.8664608.3966961 1.3336964.3979568.6246529.0012589 1.2115326-.4206333 1.8298893-.3299599.9470615.1372681 1.5780163 1.4142914 2.5124817 1.2115307.2103157-.0465965.3954506-.1662464.5944271-.2506161.8271046-.3533726 1.3936672.0372009 1.6158009.0088234.3136635-.0411129.9965248-.8012791.9886169-1.741745-.0025139-.3866405-.1120796-.7644567-.2203941-1.1359711-.2785492-.9608679-.3587952-1.3502054-2.2694149-2.350008l.0214081-.0075636.0503788-.0163727c.1045246-.0340061.2203922-.0277033.3198814.0214148 1.4259148.7025509 2.7832909 1.7710867 3.2341118 3.3096771v.0012608c.2931519.9770088.1505699 2.0296344-.2468453 2.9570427z"
                  fill="#bf7d5a"
                ></path>
              </g>
              <g>
                <g>
                  <g>
                    <path
                      d="m22.4396515 15.9290628-.8599854.9699697-.3300171-.0699463.6200562-.7000732.0199585-.0100098c.1049061-.0362988.6249256-.2162294.5200195-.1799307z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m24.7296906 15.1690531-1.7999878 2.0400381-.0900269-.0200195-.2199707-.0500489-.0200195-.0100097 1.5599975-1.7600089.2000122-.0699462.1300049-.0499268z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m26.999649 14.4190531-2.7299805 3.1000967-.3399658-.0800781 2.5-2.8299551c.105341-.0350199.6400204-.2127666.539978-.1800537z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m29.2696686 13.6690531-3.6699829 4.1500235-.2299805-.0499268-.1000366-.0200195 3.4400024-3.9000235c.1002026-.032218.6602001-.2122717.5599976-.1800537z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m31.5096588 12.9791117-4.5599976 5.1499014-.0999756-.0198975-.2399902-.0600586 4.3899536-4.95996.1300049-.0400391.1100464-.039917h.0199585l.0500488-.0200195c.0599976-.0200195.1299439-.0300293.1999512-.0100097z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m32.5996857 13.5690775-4.3099976 4.8699942-.3400269-.0799561 4.3800049-4.9500723c.1000367.0500488.1900025.1000977.2700196.1600342z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m33.5496979 14.299058-3.9299927 4.4500723-.0200195-.0100098h-.0100098l-.210022-.0500488-.0899658-.0200195 4.0299683-4.5699453c.0800171.0599364.1600342.1300048.2300415.1999511z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m34.3496857 15.2291117-3.3800049 3.8299551-.3400269-.0799561 3.5400391-3.999999c.0599976.079956.1199951.1599121.1799927.25z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m34.8896637 16.4390717-2.5799561 2.9200439-.1800537-.0400391-.1599731-.039917 2.8099976-3.1800537c.0680656.1585408.082283.2291565.1099853.3399659z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      d="m35.0096588 17.6690521c-.0633316.6333103-.0599976.4842129-.0599976.5200195l-1.3099976 1.4799805-.039978-.0100098-.289978-.0699463z"
                      fill="#8a4852"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g opacity=".3">
            <path
              d="m28.7791653 11.3568249c-.0264492.113348-.0692654.2203932-.1297131.3223953-.1002083-.0047932-12.6667299-.6058416-11.6883888-.5591612-1.8903437-.9571476-3.017498-2.124588-2.7933311-3.1069174.3538885-1.5452576 3.9116611-2.0502739 7.945488-1.1271472 4.0363406.924387 7.0185718 2.9242969 6.665945 4.4708305z"
              fill="#fafdfc"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  bleuCheese: (props) => (
    <svg
      height="512"
      viewBox="0 0 58 45"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_3390424"
      {...props}
    >
      <g id="Page-1" fill="none" fill-rule="evenodd">
        <g id="013---Cheese-Wheel" fill-rule="nonzero">
          <path
            id="Shape"
            d="m29 .98c-16.02 0-29 4.92-29 11v23c0 4.46 6.97 8.29 17 10.02v-.02l12-10 12 10v.02c10.03-1.73 17-5.56 17-10.02v-23c0-6.08-12.98-11-29-11z"
            fill="#f9eab0"
          ></path>
          <path
            id="Shape"
            d="m58 11.98v23c0 4.46-6.97 8.29-17 10.02v-23c10.03-1.73 17-5.56 17-10.02z"
            fill="#f0c419"
          ></path>
          <path
            id="Shape"
            d="m17 22v23c-10.03-1.73-17-5.56-17-10.02v-23c0 4.46 6.97 8.29 17 10.02z"
            fill="#f3d55b"
          ></path>
          <path id="Shape" d="m41 21.98v23l-12-10v-23z" fill="#b19046"></path>
          <path id="Shape" d="m29 11.98v23l-12 10v-23z" fill="#e4c05c"></path>
          <circle id="Oval" cx="36" cy="30.98" fill="#7f6e5d" r="2"></circle>
          <g fill="#b19046">
            <circle id="Oval" cx="23" cy="25.98" r="2"></circle>
            <circle id="Oval" cx="22" cy="32.98" r="1"></circle>
            <circle id="Oval" cx="29" cy="18.98" r="1"></circle>
          </g>
          <circle id="Oval" cx="33" cy="24.98" fill="#7f6e5d" r="1"></circle>
          <path
            id="Shape"
            d="m42.249 18.81c-.515367-.000453-.9459866-.3925055-.9946526-.9055698-.0486661-.5130643.3005618-.9790882.8066526-1.0764302 6.866-1.328 9.939-3.389 9.939-4.848 0-2.5-8.75-6-23-6s-23 3.5-23 6c0 1.458 3.068 3.52 9.92 4.845.4814297.0805394.8343685.4968804.835.985-.0046599.2976381-.1398683.5781949-.3697745.7672803-.2299063.1890854-.5312851.2675978-.8242255.2147197-4.318-.833-11.561-2.825-11.561-6.812 0-5.2 12.88-8 25-8s25 2.8 25 8c0 3.987-7.243 5.979-11.561 6.812-.0626373.0118845-.1262452.0179105-.19.018z"
            fill="#e4c05c"
          ></path>
        </g>
      </g>
    </svg>
  ),
};
